import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-033070a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex gap-1" }
const _hoisted_2 = { class: "row row-cols-2 g-5" }
const _hoisted_3 = { class: "row row-cols-2 g-5" }
const _hoisted_4 = { class: "row row-cols-2 g-5" }
const _hoisted_5 = { class: "row row-cols-2 g-5" }
const _hoisted_6 = { class: "row row-cols-2 g-5" }
const _hoisted_7 = { class: "row row-cols-2 g-5" }

import { ref } from "vue";
import { Check } from "@element-plus/icons-vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import EventV2Services from "../../services/EventV2Services";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import { AccessRoles, PointRoles } from "@/core/types/shop/ShopEventRoles";
import UploadImage from "../../../events/components/shop/UploadImage.vue";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditNormalEvent',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {



const isSubmitting = ref(false);
const activeTab = ref("content");
const uploadImageRef = ref<any>(null);
const uploadMobileImageRef = ref<any>(null);
const pointItem = ref("all");
const langItem = ref("");
const langOptions = ref<any[]>(
  LanguageTypes.all.map((l: any) => ({ ...l, isAdded: false }))
);
const formData = ref<any>({});
const languageFormData = ref<any>(null);
const contentList = ref<any>({});
const imageList = ref<any>({});

const accessRoles = AccessRoles;

const defaultLangContent = () => ({
  name: "",
  description: "<p>description</p>",
  term: "<p>term</p>",
  images: {},
  instruction: {
    pointsRule: {
      all: "<p>all</p>",
      agent: "<p>agent</p>",
      sales: "<p>sales</p>",
      client: "<p>client</p>",
    },
  },
});

const languageExists = (lang: string) => {
  const item = langOptions.value.find((o) => o.code === lang);
  if (item) item.isAdded = true;
};

const fetchImage = async (data: any) => {
  if (data.images && Object.keys(data.images).length > 0) {
    if (imageList.value[langItem.value]) {
      if (uploadImageRef.value)
        uploadImageRef.value.imageUrl =
          imageList.value[langItem.value]["desktop"] || "";
      if (uploadMobileImageRef.value)
        uploadMobileImageRef.value.imageUrl =
          imageList.value[langItem.value]["mobile"] || "";
      return;
    }
    if (data.images["desktop"]) {
      if (!imageList.value[langItem.value])
        imageList.value[langItem.value] = {};
      imageList.value[langItem.value]["desktop"] = data.images["desktop"];
      if (uploadImageRef.value)
        uploadImageRef.value.imageUrl = data.images["desktop"];
    } else if (uploadImageRef.value) {
      uploadImageRef.value.imageUrl = "";
    }
    if (data.images["mobile"]) {
      if (!imageList.value[langItem.value])
        imageList.value[langItem.value] = {};
      imageList.value[langItem.value]["mobile"] = data.images["mobile"];
      if (uploadMobileImageRef.value)
        uploadMobileImageRef.value.imageUrl = data.images["mobile"];
    } else if (uploadMobileImageRef.value) {
      uploadMobileImageRef.value.imageUrl = "";
    }
  } else {
    if (uploadImageRef.value) uploadImageRef.value.imageUrl = "";
    if (uploadMobileImageRef.value) uploadMobileImageRef.value.imageUrl = "";
  }
};

const load = async (item: any) => {
  isSubmitting.value = true;
  activeTab.value = "content";
  try {
    const res = await EventV2Services.queryEventById(item.id);
    formData.value = res;
    contentList.value = {};
    imageList.value = {};
    langOptions.value.forEach((o) => (o.isAdded = false));
    for (const lang of res.languages) {
      if (!lang.instruction)
        lang.instruction = defaultLangContent().instruction;
      if (lang.name === undefined) lang.name = "";
      contentList.value[lang.language] = lang;
      languageExists(lang.language);
    }
    langItem.value = res.languages[0].language;
    languageFormData.value = contentList.value[langItem.value];
    await fetchImage(languageFormData.value);
  } catch (error) {
    MsgPrompt.error(error);
  }
  isSubmitting.value = false;
};

const switchLang = async (lang: string) => {
  if (langItem.value === lang) return;
  langItem.value = lang;
  if (!contentList.value[lang]) contentList.value[lang] = defaultLangContent();
  languageFormData.value = contentList.value[lang];
  await fetchImage(languageFormData.value);
};

const uploadImg = async (file: any) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await EventV2Services.uploadImage(fd);
  return res["url"];
};

const getModules = (index: number) => [
  {
    name: "imageUploader" + index,
    module: ImageUploader,
    options: { upload: (file) => uploadImg(file) },
  },
  { name: "blotFormatter" + index, module: BlotFormatter },
];

const submitContent = async () => {
  try {
    await uploadMobileImageRef.value?.uploadImage().then(() => {
      if (uploadMobileImageRef.value?.imageUrls?.length > 0) {
        languageFormData.value.images = languageFormData.value.images || {};
        languageFormData.value.images["mobile"] =
          uploadMobileImageRef.value.imageUrls[0];
      }
    });
    await uploadImageRef.value?.uploadImage().then(() => {
      if (uploadImageRef.value?.imageUrls?.length > 0) {
        languageFormData.value.images = languageFormData.value.images || {};
        languageFormData.value.images["desktop"] =
          uploadImageRef.value.imageUrls[0];
      }
    });
    languageFormData.value.name = languageFormData.value.title || "";
    await EventV2Services.updateEventLanguage(
      formData.value.id,
      langItem.value,
      languageFormData.value
    );
    languageExists(langItem.value);
    MsgPrompt.success(langItem.value + " updated successfully");
    emits("submit");
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const submitDetail = async () => {
  try {
    await EventV2Services.updateEvent(formData.value.id, {
      ...formData.value,
      languages: undefined,
    });
    MsgPrompt.success("Detail updated successfully");
    emits("submit");
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const submit = async () => {
  isSubmitting.value = true;
  if (activeTab.value === "content") {
    await submitContent();
  } else {
    await submitDetail();
  }
  isSubmitting.value = false;
};

__expose({ load, submit, isSubmitting });

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      type: "card",
      class: "mb-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "Content",
          name: "content"
        }),
        _createVNode(_component_el_tab_pane, {
          label: "Detail",
          name: "detail"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (languageFormData.value)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          ref: "contentFormRef",
          model: languageFormData.value,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.language'),
              class: "mb-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: langItem.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((langItem).value = $event)),
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: item.code,
                        label: item.code,
                        onClick: ($event: any) => (switchLang(item.code))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, _toDisplayString(item.code), 1),
                            (item.isAdded)
                              ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Check))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.eventTitle')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: languageFormData.value.title,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((languageFormData.value.title) = $event)),
                    disabled: isSubmitting.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('action.uploadDesktopImage')
              }, {
                default: _withCtx(() => [
                  _createVNode(UploadImage, {
                    ref_key: "uploadImageRef",
                    ref: uploadImageRef
                  }, null, 512)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('action.uploadMobileImage')
              }, {
                default: _withCtx(() => [
                  _createVNode(UploadImage, {
                    ref_key: "uploadMobileImageRef",
                    ref: uploadMobileImageRef
                  }, null, 512)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.content')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(QuillEditor), {
                  theme: "snow",
                  content: languageFormData.value.description,
                  "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((languageFormData.value.description) = $event)),
                  modules: getModules(1),
                  contentType: "html",
                  toolbar: "full",
                  enable: !isSubmitting.value
                }, null, 8, ["content", "modules", "enable"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('title.termsAndConditions')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(QuillEditor), {
                  theme: "snow",
                  content: languageFormData.value.term,
                  "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((languageFormData.value.term) = $event)),
                  modules: getModules(2),
                  contentType: "html",
                  toolbar: "full",
                  enable: !isSubmitting.value
                }, null, 8, ["content", "modules", "enable"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.pointsRules')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: pointItem.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pointItem).value = $event)),
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PointRoles), (r) => {
                      return (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: r.value,
                        label: r.value,
                        onClick: ($event: any) => (pointItem.value = r.value)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(r.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.content')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(QuillEditor), {
                  theme: "snow",
                  content: languageFormData.value.instruction.pointsRule[pointItem.value],
                  "onUpdate:content": _cache[6] || (_cache[6] = ($event: any) => ((languageFormData.value.instruction.pointsRule[pointItem.value]) = $event)),
                  modules: getModules(3),
                  contentType: "html",
                  toolbar: "full",
                  enable: !isSubmitting.value
                }, null, 8, ["content", "modules", "enable"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])), [
          [_vShow, activeTab.value === 'content']
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_el_form, {
      ref: "detailFormRef",
      model: formData.value,
      "label-position": "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.eventKey')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.key,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.key) = $event)),
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.accessRoles')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: formData.value.accessRoles,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.accessRoles) = $event)),
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessRoles), (r) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: r.value,
                      label: r.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(r.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.site')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: formData.value.accessSites,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.accessSites) = $event)),
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (s) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: s.value,
                      label: s.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(s.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.applyStartDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.applyStartOn,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.applyStartOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.applyEndDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.applyEndOn,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.applyEndOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.eventStartDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.startOn,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.startOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.eventEndDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.endOn,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.endOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["model"]), [
      [_vShow, activeTab.value === 'detail']
    ])
  ], 64))
}
}

})